import { View } from '@react-pdf/renderer';
import LogoBolsaCerealesSVG from './LogoBolsaCerealesSVG';

const Header = () => {
  return (
    <View fixed style={{ alignItems: 'flex-start', marginBottom: 18 }}>
      <View style={{ marginBottom: 26 }}>
        <LogoBolsaCerealesSVG width="140px" height="32px" />
      </View>
      <View style={{ borderBottom: '1px solid #E4E7EC', width: '100%' }}></View>
    </View>
  );
};

export default Header;
